import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, defineAsyncComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FaIcon',
  props: {
  icon: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const IconSolid = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/fontawesome-solid" */ '@/components/FaIcon/IconSolid.vue'));
const IconRegular = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/fontawesome-regular" */ '@/components/FaIcon/IconRegular.vue'));
const IconLight = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/fontawesome-light" */ '@/components/FaIcon/IconLight.vue'));
const IconThin = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/fontawesome-thin" */ '@/components/FaIcon/IconThin.vue'));

const props = __props;

const mappedIconName = computed(() => `${props.icon || ''}`.trim()
  .replace('far ', 'fa-regular ')
  .replace('fas ', 'fa-solid ')
  .replace('fat ', 'fa-thin ')
  .replace('fal ', 'fa-light '));

const iconComponent = computed(() => {
  if (mappedIconName.value.startsWith('fa-regular')) {
    return IconRegular;
  }
  if (mappedIconName.value.startsWith('fa-solid')) {
    return IconSolid;
  }
  if (mappedIconName.value.startsWith('fa-thin')) {
    return IconThin;
  }
  return IconLight;
});

return (_ctx: any,_cache: any) => {
  return (__props.icon)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(iconComponent.value), {
        key: mappedIconName.value,
        icon: mappedIconName.value
      }, null, 8, ["icon"]))
    : _createCommentVNode("", true)
}
}

})